module.exports = __webpack_public_path__ + "static/russian-fae94ea1d046afdcd87180dcc2ea92bc.jpg";